import React from "react"
import Block from "@bappweb/block"
import Link from "@bappweb/link"
import Button from "@bappweb/button"

const Toolbar = (props) => {
  let buttonOrLinkWithButton
  if (props.scrollHref){
    buttonOrLinkWithButton =
    <Link href={props.scrollHref}>
      <Button text={props.text} />
    </Link>
  } else {
    buttonOrLinkWithButton = <Button text={props.text} onClick={props.onApplyClick} />
  }

  return props.isVisible ? (
    <Block className="fixed-toolbar">
      <Block className="fixed-toolbar-content">
        {buttonOrLinkWithButton}
      </Block>
    </Block>
  ) : null
}

export default Toolbar